<mat-drawer-container class="app-container">
  <mat-drawer mode="side" [opened]="true" [class.mini]="!sidenav.isExpanded()">
    <app-sidenav #sidenav />
  </mat-drawer>

  <mat-drawer-content [class.expanded]="sidenav.isExpanded()" [class.mini]="!sidenav.isExpanded()">
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
    <app-feedback-widget />
  </mat-drawer-content>
</mat-drawer-container>

@defer {
  <app-ebbot-chat></app-ebbot-chat>
}
